import React, { useEffect, useState } from "react";
import "./CartProductCard.css";
import { faAngleRight, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import IncrementDecrementBtn from "../../common_components/Increment_Decrement_Btn/Increment_Decrement_Btn";
import { getAllCart } from "../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";

import Increment_Decrement_Btn_Cart from "../../common_components/Increment_Decrement_Btn/Increment_Decrement_Btn_Cart";
import { encodeId } from "../../../utils/common";
import { useNavigate } from "react-router-dom";

const CartProductCard = ({ saveTotal, customClass, ...props }) => {
  const allCart = useSelector((state) => state.cart.allCarts);
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();

  // useEffect(() => {
  //     dispatch(getAllCart(isSignIn));
  // }, []);

  const [totalSaving, setTotalSaving] = useState();
  const [totaAmount, setTotalAmount] = useState();
  const [count, setCount] = useState();
  const inCart = useSelector((state) => state.cart.checkItem);

  const [
    show_Select_Product_By_Weight_Modal,
    set_show_Select_Product_By_Weight_Modal,
  ] = useState(false);

  const navigate = useNavigate();
  return (
    <div className="CartProductCard">
      <div className="product_content">
        <div className="product_detail_inner">
          <div className="row row_class">
            <div
              className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-8"
              onClick={() =>
                navigate(`/product-description/${encodeId(props?.cartVarient?.Product?.id)}`)
              }
              // onClick={() => set_show_Select_Product_By_Weight_Modal(true)}
            >
              <div className="left_side">
                <div className="img_holder">
                  <img src={process.env.REACT_APP_IMG_URL + props?.img} />
                </div>

                <div className="text_holder">
                  <div className="product_name">
                    <p>{props?.title}</p>
                  </div>
                  <div className="weight">
                    <p>
                      {props?.cartVarient?.Product_Variant?.name}{" "}
                      {props?.cartVarient?.Product?.Unit?.name}
                    </p>
                  </div>
                  <div className="price_section">
                    <div className="selling_price">
                      <p>₹ {props?.cartVarient?.Product_Variant?.price}</p>
                    </div>

                    <div className="mrp">
                      <p>₹ {props?.cartVarient?.Product_Variant?.mrp}</p>
                    </div>
                  </div>

                  <div className="addon_catagory_list_holder">
                    <ul>
                      <li>
                        {props?.cartVarient?.Cart_Addon_Multiples?.map(
                          (val) => (
                            <div className="addon_text_holder">
                              <div className="product_name">
                                <h5>
                                  {val?.Addon_Category?.name} :
                                  {val?.Addon?.name}
                                </h5>
                              </div>
                            </div>
                          )
                        )}
                        {props?.cartVarient?.Cart_Addon_Singles?.map((val) => (
                          <div className="addon_text_holder">
                            <div className="product_name">
                              <h5>
                                {val?.Addon_Category?.name} :{val?.Addon?.name}
                              </h5>
                            </div>
                          </div>
                        ))}
                      </li>

                      {props?.cartVarient.selectedAddOns &&
                        Object.values(props.cartVarient.selectedAddOns).map(
                          (addonArray) =>
                            addonArray.map((addon) => (
                              <li key={addon.product_addon_id}>
                                <div className="addon_text_holder">
                                  <div className="product_name">
                                    <h5>
                                      {addon.addon_category_name} :{" "}
                                      {addon.addon_name}
                                    </h5>
                                  </div>
                                </div>
                              </li>
                            ))
                        )}
                    </ul>

                    {/* {props?.cartVarient?.Cart_Addon_Multiples?.map((val)=>
                    <>
                    {val?.Addon_Category?.name}:{val?.Addon?.name}
                    </>
                    )} 
                   
                    {props?.cartVarient?.Cart_Addon_Singles?.map((val)=>
                    <>
                     {val?.Addon_Category?.name}:{val?.Addon?.name}
                    </>
                    )} */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-4">
              <div className="right_side">
                <Increment_Decrement_Btn_Cart
                  varientId={props?.cartVarient?.Product_Variant?.id}
                  cart={allCart?.data?.data}
                  varient={props?.cartVarient?.Product_Variant}
                  product={props?.cartVarient?.Product}
                  productId={props?.cartVarient?.product_id}
                  cartId={props?.cartVarient?.id}
                  isSignIn={isSignIn}
                  totalSaving={totalSaving}
                  setTotalSaving={setTotalSaving}
                  totaAmount={totaAmount}
                  cartVarient={props?.cartVarient}
                  setTotalAmount={setTotalAmount}
                  saveTotal={saveTotal}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Select_Product_Cart_Modal
        selectedVariant={props?.cartVarient?.Product_Variant}
        // setSelectedVariant={setSelectedVariant}
        product={props?.cartVarient?.Product}
        show={show_Select_Product_By_Weight_Modal}
        onHide={() => set_show_Select_Product_By_Weight_Modal(false)}
      /> */}
    </div>
  );
};

export default CartProductCard;
